<template>
    <div class="guidTwoRoot">
      <div class="backPageItem"><BackPageVue  @backPreviewPage="hanldGoBack"></BackPageVue> </div>

      <div class="titleBox">
        <div class="titleLine">We Help Researchers Get the Recognition</div>
        <div class="subTitle">PaperSpotlight is your <strong>ethical</strong> academic <strong>marketing</strong> partner — we <strong>promote</strong> your work with <strong>integrity</strong>, <strong>clarity</strong>, and <strong>purpose</strong>. </div>
      </div>
      <div class="contentLine">
        <div class="itemLine">
          <div class="itemName">Researchers</div>
          <div class="itemName">Articles</div>
          <div class="itemName">Citations</div>
        </div>
        <div class="centerLine">
          <div class="sideBlock" style="justify-content: space-around;">
              <div class="NumItem">81.3%</div>
              <div class="tetItem">Never Promote their work</div>
              <div class="NumItem hiddenItem" style="visibility: hidden;">18 </div>
              <div class="NumItem">18.7%</div>
              <div class="tetItem" style="color: #FEAE00;">Actively Promote their work</div>
          </div>
          <div class="centerBlock">
            <div class="lineOne"> </div>
            <div class="lineTwo"> </div>
            <div class="columnItem">
              <div class="aboveItem"></div>
              <div class="belovwItem" style="height: 18.7%;"></div>
            </div>
            <div class="columnItem">
              <div class="aboveItem"></div>
              <div class="belovwItem" style="height: 24.7%;"></div>
            </div>
            <div class="columnItem">
              <div class="aboveItem"></div>
              <div class="belovwItem" style="height: 89.4%;"></div>
            </div>
          </div>
          <div class="sideBlock" style="justify-content: space-around;">
              <div class="NumItem">10.6%</div>
              <div class="tetItem">Limited Recognition</div>
              <div class="tetItem "  style="visibility: hidden;">Limited Recognition</div>
              <div class="NumItem">89.4%</div>
              <div class="tetItem" style="color: #FEAE00;">Limited Recognition</div>
              <div class="NumItem hiddenItem" style="visibility: hidden;">89</div>
          </div>
        </div>
        <div style="display: flex;justify-content: center;">
          <div class="subTitle"> <strong>The Cost of Silence: </strong>Academic Impact Isn’t Just About Quality — It’s About <strong>Visibility.</strong> </div>
        </div>
      </div>
      
      <div class="btnLine">
          <!-- <div class="disBtn" v-if="chooseRadio==-1">Next step</div> -->
          <div class="chooseBtn"   @click="goToNextStep">Next</div>
      </div>
      <div class="LastLine">
          <div class="oneItem">© 2025 PaperSpotlight. All rights reserved.</div>
          <div class="twoItem">The data presented is based on our independent research and analysis. While we strive for accuracy, results may vary across different fields and contexts. Unauthorized reproduction or distribution of this content is prohibited.</div>
      </div> 
    </div>
</template>
<script>
import BackPageVue from './backPage.vue'

export default {
  components:{BackPageVue},

    data(){
      return{
        imgObj:{
          guideHomebg1:require("../../assets/img/main/guideHomebg1.png"),
          guideHomebg2:require("../../assets/img/main/guideHomebg2.png"),
        },
        chartInstance: null


      }
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods:{
    hanldGoBack(){
      localStorage.setItem('guideIndex', -1);
      this.$emit('changePage', -1);
    },
    goToNextStep(){
          console.log(21)
          localStorage.setItem('guideIndex', 1);
          this.$emit('changePage', 1);
      },
  }
}
</script>

<style lang="scss">
.guidTwoRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 60px 0 30px 0;
    gap: 40px;
    .backPageItem{
      position: absolute;
      left: 100px;
      top:40px;
      width: 30px;
      height: 30px;
    }
    .titleBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .titleLine{
      max-width: 900px;
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        width: 70%;
        margin-top: 16px;
        color: var(---2, #333);
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // text-transform: capitalize;
    }
    .contentLine{
      background: #eee;
      gap: 10px;
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .itemLine{
      display: flex;
      gap: 15px;
      justify-content: center;
      margin-left: 70px;
      .itemName{
        width: 120px;
        text-align: center;
        color: #000;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
      }
    }
    .centerLine{
      // flex: 1 1;
      display: flex;
      gap: 20px;
      justify-content: center;
      .sideBlock{
        display: flex;
        flex-direction: column;
        .NumItem{
          color: var(---1, #000);
          font-size: 36px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        .tetItem{
          color: #999;
          font-size: 20px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .centerBlock{
        border-top: 2px solid #000;
        box-sizing: border-box;
        height: 240px;
        gap: 80px;
        display: flex;
        position: relative;
        .lineOne{
          position: absolute;
          left: 64px;
          width: 120px;
          bottom:18.7%;
          // top:75.3%;
          height: 2px;
          background-color: #000;
          /* 设置旋转中心为左下角 */
          transform-origin: left bottom;
          /* 旋转30度 */
          transform: rotate(-11deg);
  
         }
         .lineTwo{
            position: absolute;
            left: 208px;
            width: 195px;
            bottom:24.7%;
            // top:75.3%;
            height: 2px;
            background-color: #000;
            /* 设置旋转中心为左下角 */
            transform-origin: left bottom;
            /* 旋转30度 */
            transform: rotate(-62deg);
         }
        .columnItem{
          width: 64px;
          height: 100%;
          display: flex;
          flex-direction: column;
          .aboveItem{
            flex: 1 1;
            width: 100%;
            background: #000;
          }
          .belovwItem{
            width: 100%;
            background: #FEAE00;
          }
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 12px 40px;
            border-radius: 8px;
            font-size: 16px;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 6px;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 22px; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}
@media screen and (max-width:767px) { 
.guidTwoRoot{
      width: 100%;
      // height: 100%;
      min-height: 100%;
      display: flex;
      flex-direction: column;
      padding: 10vw 0;
      gap: 10vw;
      .backPageItem{
        position: absolute;
        left: 2vw;
        top:3vw;
        width: 4vw;
        height: 4vw;
      }
      .titleBox{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      padding: 0 6vw;

      }
      .titleLine{
        max-width: 900px;
        color: #000;
        text-align: center;
        font-family: "Times New Roman";
        font-size: 6vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
      }
      .subTitle{
          width: 100%;
          margin-top: 3vw;
          color: var(---2, #333);
          // text-align: center;
          font-size: 3.4vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          // text-transform: capitalize;
      }
      .contentLine{
        gap: 3vw;
        flex: 1 1;
        display: flex;
        flex-direction: column;
      padding: 0 6vw;
        
      }
      .itemLine{
        display: flex;
        gap: 6vw;
        justify-content: center;
        margin-left: 0;
        .itemName{
          width: auto;
          text-align: center;
          color: #000;
          font-size: 4vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
      }
      .centerLine{
        // flex: 1 1;
        display: flex;
        gap: 3vw;
        justify-content: center;
        .sideBlock{
          display: flex;
          flex-direction: column;
          .hiddenItem{
            display: none !important;
          }
          .NumItem{
            color: var(---1, #000);
            font-size: 4vw;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
          .tetItem{
            color: #999;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
        }
        .centerBlock{
          border-top: 2px solid #000;
          box-sizing: border-box;
          height: 48vw;
          gap: 12vw;
          display: flex;
          position: relative;
          .lineOne{
            position: absolute;
            left: 9.6vw;
            width: 17vw;
            bottom:18.7%;
            // top:75.3%;
            height: 2px;
            background-color: #000;
            /* 设置旋转中心为左下角 */
            transform-origin: left bottom;
            /* 旋转30度 */
            transform: rotate(-12deg);
    
          }
          .lineTwo{
              position: absolute;
              left: 31.2vw;
              width:35vw;
              bottom:24.7%;
              // top:75.3%;
              height: 2px;
              background-color: #000;
              /* 设置旋转中心为左下角 */
              transform-origin: left bottom;
              /* 旋转30度 */
              transform: rotate(-68deg);
          }
          .columnItem{
            width: 9.6vw;
            height: 100%;
            display: flex;
            flex-direction: column;
            .aboveItem{
              flex: 1 1;
              width: 100%;
              background: #000;
            }
            .belovwItem{
              width: 100%;
              background: #FEAE00;
            }
          }
        }
      }
      .btnLine{
            display: flex;
          justify-content: center;
          align-items: center;
          .disBtn{
              display: inline-block;
              background: #E0E0E0;
              color: #fff;
              padding: 1.2vw 4vw;
              border-radius: 8px;
              font-size: 3.4vw;
          }
          .chooseBtn{
              cursor: pointer;
              display: inline-block;
              background: #212121;
              color: #fafafa;
              padding: 1.2vw 4vw;
              border-radius: 8px;
              font-size: 3.4vw;
          }
          .chooseBtn:hover{
              background: #424242;
          }
          .chooseBtn:active{
              background: #212121;
          }
          

      }
      .LastLine{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          gap: 1vw;
          .oneItem{
            color: var(---1, #000);
            text-align: center;
            font-size: 3.4vw;
            font-style: normal;
            font-weight: 400;
            line-height: 1.3; /* 110% */
          }
          .twoItem{
            width: 90%;
            max-width: 900px;
            color: #aaa;
            text-align: center;
            font-size: 3vw;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }
      }
  }
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
  .guidTwoRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    padding: 6vw 0 3vw 0;
    gap: 4vw;
    .backPageItem{
      position: absolute;
      left: 6vw;
      top:2vw;
      width: 5vw;
      height: 5vw;
    }
    .titleBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
    .titleLine{
      max-width: 700px;
      color: #000;
      text-align: center;
      font-family: "Times New Roman";
      font-size: 3.2vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
    }
    .subTitle{
        margin-top: 1.6vw;
        color: var(---2, #333);
        // text-align: center;
        font-size: 1.6vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        // text-transform: capitalize;
    }
    .contentLine{
      gap: 1vw;
      flex: 1 1;
      display: flex;
      flex-direction: column;
    }
    .itemLine{
      display: flex;
      gap: 1.5vw;
      justify-content: center;
      margin-left: 7vw;
      .itemName{
        width: 12vw;
        text-align: center;
        color: #000;
        font-size: 2vw;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
      }
    }
    .centerLine{
      // flex: 1 1;
      display: flex;
      gap: 20px;
      justify-content: center;
      .sideBlock{
        display: flex;
        flex-direction: column;
        .NumItem{
          color: var(---1, #000);
          font-size: 2vw;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
        .tetItem{
          color: #999;
          font-size: 2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      .centerBlock{
        border-top: 2px solid #000;
        box-sizing: border-box;
        height: 240px;
        gap: 80px;
        display: flex;
        position: relative;
        .lineOne{
          position: absolute;
          left: 64px;
          width: 120px;
          bottom:18.7%;
          // top:75.3%;
          height: 2px;
          background-color: #000;
          /* 设置旋转中心为左下角 */
          transform-origin: left bottom;
          /* 旋转30度 */
          transform: rotate(-11deg);
  
         }
         .lineTwo{
            position: absolute;
            left: 208px;
            width: 195px;
            bottom:24.7%;
            // top:75.3%;
            height: 2px;
            background-color: #000;
            /* 设置旋转中心为左下角 */
            transform-origin: left bottom;
            /* 旋转30度 */
            transform: rotate(-62deg);
         }
        .columnItem{
          width: 64px;
          height: 100%;
          display: flex;
          flex-direction: column;
          .aboveItem{
            flex: 1 1;
            width: 100%;
            background: #000;
          }
          .belovwItem{
            width: 100%;
            background: #FEAE00;
          }
        }
      }
    }
    .btnLine{
          display: flex;
        justify-content: center;
        align-items: center;
        .disBtn{
            display: inline-block;
            background: #E0E0E0;
            color: #fff;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn{
            cursor: pointer;
            display: inline-block;
            background: #212121;
            color: #fafafa;
            padding: 1.2vw 4vw;
            border-radius: 8px;
            font-size: 1.6vw;
        }
        .chooseBtn:hover{
            background: #424242;
        }
        .chooseBtn:active{
            background: #212121;
        }
        

    }
    .LastLine{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 0.6vw;
        .oneItem{
          color: var(---1, #000);
          text-align: center;
          font-size: 1.6vw;
          font-style: normal;
          font-weight: 400;
          line-height: 1.3; /* 110% */
        }
        .twoItem{
          width: 90%;
          max-width: 900px;
          color: #aaa;

          text-align: center;
          font-size: 1.2vw;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
    }
}  
}
</style>